<template>
  <div>
    <section class="hero is-grey-ligth mainContent">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title has-text-dark">Gráficas</h1>
              <h2 class="subtitle has-text-dark">{{ subtitle }}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section mainContent">
      <div class="container">
        <div class="tabs topSubMenu">
          <ul
            class="selectedMenu"
            id="listgraphi"
            @click="navigateSelect('listgraphi', 'Lista')"
          >
            <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'graphicsmenu.graphbycompany' }"
            >
              <li @click="navigate" @keypress.enter="navigate" role="link">
                <a>Lista de Gráficas</a>
              </li>
            </router-link>
          </ul>
          <ul
            id="createGraphi"
            @click="navigateSelect('createGraphi', 'Crear')"
          >
            <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'graphicsmenu.graphics' }"
            >
              <li @click="navigate" @keypress.enter="navigate" role="link">
                <a>Crear Gráficas</a>
              </li>
            </router-link>
          </ul>
        </div>

        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subtitle: "Lista",
    };
  },
  methods: {
    subTitle(s) {
      this.subtitle = s;
    },
    navigateSelect(name, s) {
      let ul = document.getElementsByTagName("ul");

      for (let i = 0; i < ul.length; i++) {
        ul[i].classList.remove("selectedMenu");
      }

      let ele = document.getElementById(name);
      ele.classList.add("selectedMenu");

      this.subTitle(s);
    },
  },
  created() {
    this.$router.push("graphicsmenu/graphbycompany");
  },
};
</script>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #07689f;
  color: #07689f;
}

.mainContent {
  padding: 0px 60px;
}

.topSubMenu {
  padding: 0px 60px;
  margin: 10px 0px 5px 0px;
}

.selectedMenu li a {
  color: #510087;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/graficas/GraphicsMenu.vue